export default "__VITE_ASSET__UetGc1KC__"